import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import SingleUserBaseMixin from '@/components/ViewComponent/Thanks/AddThanksMessage/single-user-base.mixin';
import { UseService } from '@/services/service';
import GiftService from '@/services/gift.service';
import { GiftEntity } from '@/entities/gift.entity';
import { ValidationObserver } from 'vee-validate';
import { StaffEntity } from '@/entities/staff.entity';

@Component<ThanksBtnMixin>({})
export default class ThanksBtnMixin extends SingleUserBaseMixin {
  currentStaff!: StaffEntity;

  @Prop({ type: Number })
  minHeight!: number;

  dialog = false;

  loading = false;

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  giftData: Partial<GiftEntity> = {
    categoryId: null,
    gift: null,
    message: null,
    staffToId: null,
  };

  @UseService(GiftService)
  service: GiftService;

  @Watch('dialog')
  onDialogChanged(value: boolean) {
    this.$store.commit('gift/setThanksMessageDialog', value);
  }
  
  @Watch('giftData', { deep: true })
  onGiftDataChanged(value: Partial<GiftEntity>) {
    this.$store.commit('gift/setGiftData', value)
  }


  created() {
    this.giftData.staffToId = this.user.id;
  }

  async send() {
    if (this.loading) {
      return;
    }
    try {
      this.loading = true;
      await this.$nextTick();
      await this.service.createOne(this.giftData);
      this.dialog = false;
      this.giftData.categoryId = null;
      this.giftData.gift = null;
      this.giftData.message = null;
      this.form.reset();
      this.$emit('hide-avatar');
    } catch (e) {
      if (e?.response?.status === 400) {
        const errors: { field: string; errors: string[] }[] =
          e.response.data.message || [];
        const veeErrors: Record<string, string[] | string> = {};
        errors.forEach((error) => {
          veeErrors[error.field] = error.errors.map(
            (k) => this.$t(`validation.${k}`) as string,
          );
        });
        this.form.setErrors(veeErrors);
      } else {
        console.error(e);
      }
    } finally {
      this.loading = false;
    }
  }
}
